export default function (Component) {
      Component.options.__i18n = {"loading":{"en":"loading","zh-CN":"加载中"}}
    }